import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class omsPackagesIndicationCtrl implements IController {

  isPacked: boolean;
  isMedium: boolean;
  packages: any[];

  private totalPackages: any;

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.packages) {
      this.totalPackages = this._getTotalItems(this.packages);
    }
  }

  private _getTotalItems(packages) {
    return _.reduce(packages || [], (sum, item) => {
      return sum + item.count;
    }, 0);
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsPackagesIndication', {
    bindings: {
      isPacked: '<?',
      isMedium: '<?',
      packages: '<'
    },
    template: require('./oms-packages-indication.html').default,
    controller: omsPackagesIndicationCtrl
  });
